import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, Paper, Stack, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export const SolicitudEquiposModal = ({ open = false, solicitudDefaultValues = {}, setOpen, solicitudEquiposInsumos }) => {
  const { control, watch, setValue, handleSubmit, reset } = useFormContext();

  const opciones = [
    {
      label: 'Usuario',
      name: 'usuario',
    },
    {
      label: 'Correo',
      name: 'correo',
    },
    {
      label: 'Transdoc',
      name: 'transdoc',
    },
    {
      label: 'PC',
      name: 'pc',
    },
    {
      label: 'Impresora/Copiadora/Escaner',
      name: 'impresora',
    },
    {
      label: 'Flota',
      name: 'flota',
    },
    {
      label: 'Teléfono Fijo',
      name: 'telefonoFijo',
    },
  ];

  return (
    <Dialog PaperProps={{ sx: { width: '50%', height: '40%' } }} open={open}>
      <DialogTitle align="center">Solicitud de Equipos e Insumos</DialogTitle>
      <Divider />
      <DialogContent>
        <form id="formSolicitud" onSubmit={handleSubmit(solicitudEquiposInsumos)}>
          <Stack display="flex" alignItems="end">
            <FormGroup>
              <Controller
                key={name}
                name="noAplica"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Switch
                        onClick={() => setValue('solicitud', solicitudDefaultValues)}
                        color="error"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="No Aplica"
                  />
                )}
              />
            </FormGroup>
          </Stack>
          <Paper elevation={3}>
            <Grid p={2} container gap={3} justifyContent="center" mt={2}>
              <Grid item>
                <FormGroup>
                  {opciones.slice(0, 4).map(({ label, name }) => (
                    <Controller
                      key={name}
                      name={`solicitud.${name}`}
                      control={control}
                      render={({ field }) => (
                        <FormControlLabel
                          disabled={watch('noAplica')}
                          control={<Switch checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                          label={label}
                        />
                      )}
                    />
                  ))}
                </FormGroup>
              </Grid>
              <Grid item>
                <FormGroup>
                  {opciones.slice(4, 7).map(({ label, name }) => (
                    <Controller
                      key={name}
                      name={`solicitud.${name}`}
                      control={control}
                      render={({ field }) => (
                        <FormControlLabel
                          disabled={watch('noAplica')}
                          control={<Switch checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                          label={label}
                        />
                      )}
                    />
                  ))}
                </FormGroup>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </DialogContent>
      <Divider />
      <DialogActions className="justify-content-center">
        <div>
          <button
            onClick={() => {
              setOpen(false);
              reset();
            }}
            type="button"
            className="btn btn-danger me-2"
          >
            <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
            Cancelar
          </button>
          <button form="formSolicitud" type="submit" className="btn btn-primary-mem">
            <SaveIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
            Guardar
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
